import { baseApi } from '../../../shared/api/baseApi';
import type { NewsArticle, NewsListParams, NewsListResponse } from '../model/types';

export const NEWS_PAGE_SIZE = 5;

export const newsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getNews: builder.query<NewsListResponse, NewsListParams>({
            query: ({
                page_num = 1,
                page_size = NEWS_PAGE_SIZE,
                query = '',
                sort_by = 'created_at',
                sort_order = 'desc',
            }) => ({
                url: '/api/admin/news',
                params: { page_num, page_size, query, sort_by, sort_order },
            }),

            serializeQueryArgs: ({ endpointName }) => endpointName,

            merge: (cache, incoming) => {
                if (incoming.page_num === 1) {
                    return incoming;
                }
                return { ...incoming, data: [...cache.data, ...incoming.data] };
            },

            forceRefetch: ({ currentArg, previousArg }) => currentArg?.page_num !== previousArg?.page_num,

            providesTags: ['News'],
        }),

        getLatestNews: builder.query<NewsListResponse, { page_size?: number } | void>({
            query: (arg) => ({
                url: '/api/admin/news',
                params: {
                    page_num: 1,
                    page_size: arg?.page_size ?? 3,
                    query: '',
                    sort_by: 'created_at',
                    sort_order: 'desc',
                },
            }),
            providesTags: ['News'],
        }),

        getArticle: builder.query<NewsArticle, string>({
            query: (id) => ({ url: `/api/admin/news/${id}` }),
            providesTags: ['News'],
        }),
    }),
    overrideExisting: false,
});

export const { useGetNewsQuery, useGetLatestNewsQuery, useGetArticleQuery } = newsApi;